// Module for javascript modules that dont have typings.

import Vue from 'vue';
import VueChartkick from 'vue-chartkick';
import VueCookies from 'vue-cookies';
import Chart from 'chart.js/dist/Chart.js'

Vue.use(VueCookies);
Vue.use(VueChartkick.use(Chart));
